import { h } from "preact";

import IconProps from "./IconProps";

function IconDescription({ width, color }: Omit<IconProps, "height" | "class">) {
    return (
        <svg width={width} viewBox="0 0 16 15">
            <path fill={color} d="M16 12.002c0 .51-.385.933-.88.991l-.115.007h-2.817l-1.925 1.925L8.337 13H1c-.512 0-.934-.386-.992-.882L0 12V1C0 .486.387.064.884.006L1.001 0H15c.513 0 .936.386.993.883L16 1v11.002zM8.49.998L1.001 1 1 12.002 8.544 12h.207l1.512 1.511L11.774 12h3.23l-.003-4.477L15 7.5V1H8.5L8.49.999zM12.5 7.5c.277 0 .5.224.5.5 0 .246-.176.45-.41.492l-.09.008h-9c-.276 0-.5-.224-.5-.5 0-.246.177-.45.41-.492L3.5 7.5h9zm0-3c.277 0 .5.223.5.5 0 .246-.176.45-.41.492l-.09.008h-9c-.276 0-.5-.223-.5-.5 0-.246.177-.45.41-.492L3.5 4.5h9z"/>
        </svg>
    );
}

IconDescription.defaultProps = {
    color: "var(--teflon)",
    width: 16
};

export default IconDescription;
